/**
 * Enumeration for the device types.
 *
 * @readonly
 * @enum {string}
 */
export const DeviceTypes = {
    TACHOGRAPH: 'TACHOGRAPH',
    REMOTE_LINK: 'REMOTE_LINK',
    PND: 'PND',
    BORNA_IBUTTON: 'BORNA_IBUTTON',
    BORNA_LOGBOOK: 'BORNA_LOGBOOK',
    ECOLINK: 'ECOLINK',
    FMS: 'FMS',
    ECOROBIN: 'ECOROBIN',
    WORKSTATE_API: 'WORKSTATE_API',
    WORKSTATE_API_MOBILE: 'WORKSTATE_API_MOBILE',
    OBD: 'OBD',
    GENERIC_IDENTIFIER: 'GENERIC_IDENTIFIER',
    PLUGTOWN: 'PLUGTOWN',
    SATELLITE: 'SATELLITE',
    SPONSOR: 'SPONSOR'
}

Object.freeze(DeviceTypes)
